/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientEncounterHistoryModel } from '../../models/patient-encounter-history-model';

export interface PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Params {
  patientId: string;
  anatomyPartId: string;
  startDate?: string | null;
  endDate?: string | null;
  facilityId: string;
}

export function patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet(http: HttpClient, rootUrl: string, params: PatientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<PatientEncounterHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.path('anatomyPartId', params.anatomyPartId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<PatientEncounterHistoryModel>;
    })
  );
}

patientFacilityIdEncounterHistoryByPartPatientIdAnatomyPartIdGet.PATH = '/Patient/{facilityId}/EncounterHistoryByPart/{patientId}/{anatomyPartId}';
